export default __webpack_public_path__ + "static/media/step_0.c17e278a.jpg";